// src/common/utils/appearance.js
// Thème par défaut du module, utilisé quand aucun thème n'est reçu du portail
// (développement local, accès direct au module hors iframe).
// Reprend l'ancienne charte PortNet.

import { createTheme } from "@mui/material/styles";

const primaryColor = "#232f66";
const secondaryColor = "#4fb8cf";

const themeProperties = {
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
  },
  primaryColor: primaryColor,
  secondaryColor: secondaryColor,
};

const defaultTheme = createTheme({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: "red" },
      },
    },
  },
  ...themeProperties,
});

const appearance = {
  defaultTheme: defaultTheme,
};

export default appearance;
